export const consentTypeNames = ['tracking', 'html', 'maps', 'video', 'ads'];
